// src/utils/studentMapUtils.ts
import Papa from 'papaparse';

interface StudentInfo {
  name: string;
  email: string;
  password: string;
}

// Map of UIDs to student information
let studentMap: Record<string, StudentInfo> = {};
let isMapLoaded = false;

/**
 * Parse a CSV file and create a map of UIDs to student information
 */
export const loadStudentMapFromCSV = async (csvFile: File): Promise<void> => {
  try {
    const text = await csvFile.text();
    
    const results = Papa.parse(text, {
      header: true,
      skipEmptyLines: true
    });
    
    studentMap = {};
    
    // Create mapping from results
    results.data.forEach((row: any) => {
      if (row.UID && row.UID.trim() !== '' && row['Student Name']) {
        studentMap[row.UID] = {
          name: row['Student Name'],
          email: row['Email Address'] || '',
          password: row['Password'] || ''
        };
      }
    });
    
    isMapLoaded = true;
    
    // Save to localStorage for persistence
    localStorage.setItem('studentMap', JSON.stringify(studentMap));
    
    console.log(`Loaded ${Object.keys(studentMap).length} students`);
    
  } catch (error) {
    console.error('Error loading student map:', error);
    throw error;
  }
};

/**
 * Load the student map from localStorage if available
 */
export const loadStudentMapFromStorage = (): void => {
  const storedMap = localStorage.getItem('studentMap');
  if (storedMap) {
    try {
      studentMap = JSON.parse(storedMap);
      isMapLoaded = true;
      console.log(`Loaded ${Object.keys(studentMap).length} students from storage`);
    } catch (error) {
      console.error('Error parsing stored student map:', error);
    }
  }
};

/**
 * Get student information by UID
 */
export const getStudentByUID = (uid: string): StudentInfo | null => {
  return studentMap[uid] || null;
};

/**
 * Check if the student map is loaded
 */
export const isStudentMapLoaded = (): boolean => {
  return isMapLoaded;
};

// Initialize by loading from localStorage when the module is imported
loadStudentMapFromStorage();